var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-inner"},[_c('LeftBox1Vue'),_c('LeftBox2Vue'),_c('LeftBox3Vue'),_c('RightBox1Vue'),_c('RightBox2Vue'),_c('RightBox3Vue'),_c('WeatherVue'),_c('DateInfoVue'),_c('TopDataVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }